export default __webpack_public_path__ + "static/color-banner-2707213732ca266458598e4c898668fc.jpg";